<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <v-form ref="form" v-model="valid" lazy-validation>
      <divcard>
        <div class="card">
          <div class="card-part pt-0 px-6 py-4">
            <div class="txt-head black--text mb-2">
              <span class="theme-color-one">ส่วนที่ 1 :</span> รายละเอียด
            </div>
            <div class="txt-head black--text mb-4">
              1. ผู้รับผิดชอบโครงการ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <div class="tccl-form-flex">

              <!-- แผนงาน -->
              <div class="form-item flex-3">
                <label>แผนงาน<span class="theme-color-seven"> *</span></label>
                <SelectBox
                  placeholder="แผนงาน"
                  theme="3"
                  item-text="name"
                  item-value="value"
                  dense
                  :items="monthList"
                  v-model="form.industry_category"
                  :rules="[(v) => !!v || 'กรุณาระบุแผนงาน']"
                />
              </div>

              <!-- ปีงบประมาณ -->
              <div class="form-item flex-3">
                <label>ปีงบประมาณ<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.fiscal_year"
                  :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']"
                />
              </div>

              <!-- Owner -->
              <div class="form-item flex-3">
                <label>Owner<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.owner"
                  :rules="[(v) => !!v || 'กรุณาระบุ Owner']"
                />
              </div>

              <!-- หมวดอุตสาหกรรม -->
              <div class="form-item flex-2">
                <label>หมวดอุตสาหกรรม<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.industry_category"
                  :rules="[(v) => !!v || 'กรุณาระบุหมวดอุตสาหกรรม']"
                />
              </div>

              <!-- กลุ่มอุตสาหกรรม -->
              <div class="form-item flex-2">
                <label>กลุ่มอุตสาหกรรม<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.industry_group"
                  :rules="[(v) => !!v || 'กรุณาระบุกลุ่มอุตสาหกรรม']"
                />
              </div>

              <!-- รหัสโครงการ -->
              <div class="form-item flex-2">
                <label>รหัสโครงการ<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.project_code"
                  :rules="[(v) => !!v || 'กรุณาระบุรหัสโครงการ']"
                />
              </div>

              <!-- ชื่อโครงการ -->
              <div class="form-item flex-1">
                <label>ชื่อโครงการ<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.project_name"
                  :rules="[(v) => !!v || 'กรุณาระบุชื่อโครงการ']"
                />
              </div>

              <!-- นักวิจัย -->
              <div class="form-item flex-2">
                <label>นักวิจัย<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.researcher"
                  :rules="[(v) => !!v || 'กรุณาระบุนักวิจัย']"
                />
              </div>

              <!-- Email นักวิจัย -->
              <div class="form-item flex-2">
                <label>Email นักวิจัย<span class="theme-color-seven"> *</span></label>
                <TextField
                  theme="3"
                  v-model="form.researcher_email"
                  :rules="[
                    (v) => !!v || 'กรุณาระบุ Email นักวิจัย',
                    (v) => /.+@.+\..+/.test(v) || 'กรุณากรอก Email ให้ถูกต้อง'
                  ]"
                />
              </div>

              <!-- <Button theme="1" @onClick="submitForm">
                ต่อไป
              </Button> -->

            </div>
          </div>
        </div>
      </divcard>
    </v-form>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import SelectBox from "../../../components/input/SelectBox"

export default {
  name: "Tccl1",
  components: {
    TextField,
    Button,
    SelectBox,
    SwitchInset,
    AutoBox
  },
  props: {
    formData: { type: Object, required: true }
  },
  data() {
    return {
      form: {
        industry_category: '',
        fiscal_year: '',
        industry_group: '',
        project_code: '',
        project_name: '',
        researcher: '',
        researcher_email: '',
        owner: '',
      },
      monthList: [
        { name: "ม.ค.", value: "jan" },
        { name: "ก.พ.", value: "feb" },
        // add your actual items here
      ],
      valid: true
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler(newVal) {
        this.form = { ...newVal } // Copy prop data into local form
      }
    }
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$emit('stepChange', this.form)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tccl-form-flex {
  display: flex;
  flex-wrap: wrap;
  gap: 0px 2%;
}

.form-item {
  display: flex;
  flex-direction: column;
}

.flex-3 {
  flex: 0 0 32%;
}

.flex-2 {
  flex: 0 0 49%;
}

.flex-1 {
  flex: 0 0 100%;
}
</style>
